// Adaptive size formatter used across the edit-deliverable modal.
// Ladder: < 1000 KB → KB, < 1000 MB → MB, < 1000 GB → GB, otherwise TB.
export const formatFileSize = (bytes?: number): string => {
  if (!bytes || bytes < 0) return '';
  const kb = bytes / 1024;
  if (kb < 1000) return `${kb.toFixed(2)} KB`;
  const mb = kb / 1024;
  if (mb < 1000) return `${mb.toFixed(2)} MB`;
  const gb = mb / 1024;
  if (gb < 1000) return `${gb.toFixed(2)} GB`;
  const tb = gb / 1024;
  return `${tb.toFixed(2)} TB`;
};
